<div mb-expandable-text height="216px">
  <div class="filter__panel__content__item">
    <ng-container *ngIf="allTypeOption; else noAllOption">
      <ul>
        <li>
          <mb-checkbox (valueChange)="
              valueChangeEmitter(
                $event,
                type === 'RECOMMENDED' ? allTypeOption.type : type,
                allTypeOption
              )
            " name="{{ allTypeOption?.code }}" [value]="allTypeSelected">
            <span i18n="@@filters__description__all">
              {allTypeOption?.description, select, all_STAR {Todas las estrellas} all_MEAL {Todos
              los Planes de comida} all_PAYMENT_METHOD {Todos los métodos de pago}
              all_ACCOMMODATION_TYPE {Todos los alojamientos} all_RATING {Todas las puntuaciones}
              all_AMENITY {Todos los servicios} all_NEARBY {Todos los lugares de interés}
              all_DISCOUNTS {Todos los descuentos} all_OUTSTANDING {Todos los alojamientos}
              all_OFFERS {Todas las ofertas} other
              {{{allTypeOption?.description}}}}
            </span>
            <span *ngIf="
                allTypeOption?.count &&
                allTypeOption?.code !== 'all_OUTSTANDING' &&
                allTypeOption?.code !== 'all_OFFERS'
              ">(<span *ngIf="allTypeOption?.showPlus">+</span>{{ allTypeOption.count }})</span>
          </mb-checkbox>
        </li>

        <li *ngIf="type !== 'RECOMMENDED'; else recommended">
          <ul>
            <li *ngFor="let item of options; trackBy: trackByItems; let i = index">
              <mb-checkbox (mouseover)="setPopoverInfo(item)" (valueChange)="
                  valueChangeEmitter($event, type === 'RECOMMENDED' ? item.type : type, item)
                " name="{{ item?.code }}" [value]="item?.isApplied" [disabled]="
                  !allTypeOption &&
                  type !== 'RECOMMENDED' &&
                  type !== 'DISCOUNTS' &&
                  allTypeSelected
                ">
                <span i18n="@@filters__description__all_payment">
                  {item?.description, select, all_PAYMENT_METHOD {Todos los métodos de pago} other
                  {{{item?.description}}}}
                </span>
                <span *ngIf="
                    item?.count && item?.code !== 'all_OUTSTANDING' && item?.code !== 'all_OFFERS'
                  ">(<span *ngIf="item?.showPlus">+</span>{{ item.count }})</span>
              </mb-checkbox>
            </li>
          </ul>
        </li>
      </ul>

      <ng-template #recommended>
        <li *ngFor="let item of options; trackBy: trackByItems; let i = index">
          <mb-checkbox (mouseover)="setPopoverInfo(item)" (valueChange)="
              valueChangeEmitter($event, type === 'RECOMMENDED' ? item.type : type, item)
            " name="{{ item?.code }}" [value]="item?.isApplied" [disabled]="
              !allTypeOption && type !== 'RECOMMENDED' && type !== 'DISCOUNTS' && allTypeSelected
            ">
            <span i18n="@@filters__description__all_payment">
              {item?.description, select, all_PAYMENT_METHOD {Todos los métodos de pago} other
              {{{item?.description}}}}
            </span>
            <span *ngIf="item?.count && item?.code !== 'all_OUTSTANDING' && item?.code !== 'all_OFFERS'">(<span
                *ngIf="item?.showPlus">+</span>{{ item.count }})</span>
          </mb-checkbox>
        </li>
      </ng-template>
    </ng-container>
  </div>
  <span mb-expand i18n="@@show-more">Ver más</span>
  <span mb-collapse i18n="@@show-less">Ver menos</span>
</div>

<ng-template #noAllOption>
  <ul>
    <li *ngFor="let item of options; let first = first; trackBy: trackByItems; let i = index">
      <mb-checkbox (mouseover)="setPopoverInfo(item)"
        (valueChange)="valueChangeEmitter($event, type === 'RECOMMENDED' ? item.type : type, item)"
        name="{{ item?.code }}" [value]="item?.isApplied"
        [disabled]="first && type !== 'RECOMMENDED' && type !== 'DISCOUNTS' && allTypeSelected">
        <span i18n="@@filters__description__all_payment">
          {item?.description, select, all_PAYMENT_METHOD {Todos los métodos de pago} other
          {{{item?.description}}}}
        </span>
        <span *ngIf="item?.count && item?.code !== 'all_OUTSTANDING' && item?.code !== 'all_OFFERS'">(<span
            *ngIf="item?.showPlus">+</span>{{ item.count }})</span>
      </mb-checkbox>
    </li>
  </ul>
</ng-template>